// extracted by mini-css-extract-plugin
export default {"ContactFormGeneric":"ContactFormGeneric_ContactFormGeneric__+wYeR","stickyBottom":"ContactFormGeneric_stickyBottom__Jc4Cg"};